import { render, staticRenderFns } from "./AdvancedCusRemittanceList.vue?vue&type=template&id=39745d02&scoped=true&"
import script from "./AdvancedCusRemittanceList.vue?vue&type=script&lang=js&"
export * from "./AdvancedCusRemittanceList.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedCusRemittanceList.vue?vue&type=style&index=0&id=39745d02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39745d02",
  null
  
)

export default component.exports